import type { Ticket } from '@core/Areas/Account/Pages/Activity/types'
import { get } from '@core/Services/ApiService'

const enum LocalConstants {
  apiBase = '/$_/accountActivity/tickets',
}

export const getPendingTicketsForRaceFromApi = (raceKey: string) =>
  get<Response>({ url: `${LocalConstants.apiBase}/pending/race-card?raceSeq=${raceKey}` })

// Types

type Response = {
  tickets: Ticket[]
  totalTicketsCount: number
}
